// src/pages/qrdisplay.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { QRCodeSVG } from 'qrcode.react';
import { useSearchParams } from 'react-router-dom';
import './qrdisplay.css';

export default function InvitePrint() {
  const [searchParams] = useSearchParams();
  const inviter = searchParams.get('inviter');
  const code = searchParams.get('code');

  const API_URL = import.meta.env.VITE_API_URL;

  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [ok, setOk] = useState(false);

  useEffect(() => {
    const fetchValidate = async () => {
      if (!inviter || !code) {
        setErr('無効なURLです');
        return;
      }
      setLoading(true);
      setErr('');
      try {
        // 既存のinviteエンドポイントで妥当性だけ確認（中身は使わない）
        const r = await axios.get(
          `${API_URL}/api/invite-view/${inviter}/${code}/invite/`);
        if (r.data?.success) setOk(true);
        else setErr('QRの検証に失敗しました');
      } catch (e) {
        console.error(e);
        setErr('QRの検証に失敗しました');
      } finally {
        setLoading(false);
      }
    };
    fetchValidate();
  }, [API_URL, inviter, code]);

  if (err) {
    return (
      <div className="qd-wrap">
        <div className="qd-error">{err}</div>
      </div>
    );
  }
  if (loading || !ok) {
    return <div className="qd-wrap">読み込み中…</div>;
  }

  return (
    <div className="qd-wrap">
      {/* 印刷領域：上に見出し、下にQRだけ（ヘッダーは削除） */}
      <div className="qd-sheet">
        <div className="qd-heading">受付QRコード</div>
        <div className="qd-qr">
          <QRCodeSVG value={code} size={440} />
        </div>
      </div>
    </div>
  );
}
